import { createAction } from 'redux-actions';

import { USER_ROLES } from 'constants/general';
import fetch from 'features/common/fetch';
import user from 'features/views/user';

import * as types from './actionTypes';

export const setManagers = createAction(types.SET_MANAGERS, (managers) => ({ managers }));

export const getManagers = (campaignId, organizationStructure) => (dispatch, getState) => {
	let finalOrganizationStructure = organizationStructure;

	const currentRole = user.selectors.getCurrentRole(getState());

	if (currentRole === USER_ROLES.GUARANTOR) {
		// eslint-disable-next-line
		const orgStructureWithoutChannelId = finalOrganizationStructure.map(({ channelId, ...rest }) => ({ ...rest }));
		finalOrganizationStructure = orgStructureWithoutChannelId;
	}

	dispatch(
		fetch.actions.post(fetch.constants.urls.dashboardManagersOfRegion, {
			body: {
				campaignId,
				userRole: currentRole,
				dashboardOrganisationStructureFilters: finalOrganizationStructure,
			},
			onSuccess: [
				(response) => () => {
					if (!response.body) return;
					dispatch(setManagers(response.body));
				},
			],
		}),
	);
};

export const reload = () => (dispatch, getState) => {
	const { body } = fetch.selectors.getLastRequest(fetch.constants.urls.dashboardManagersOfRegion)(getState());
	dispatch(getManagers(body.campaignId, body.dashboardOrganisationStructureFilter));
};
